"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetImpressionPredictionToJSON = exports.AdSetImpressionPredictionFromJSONTyped = exports.AdSetImpressionPredictionFromJSON = exports.instanceOfAdSetImpressionPrediction = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdSetImpressionPrediction interface.
 */
function instanceOfAdSetImpressionPrediction(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetImpressionPrediction = instanceOfAdSetImpressionPrediction;
function AdSetImpressionPredictionFromJSON(json) {
    return AdSetImpressionPredictionFromJSONTyped(json, false);
}
exports.AdSetImpressionPredictionFromJSON = AdSetImpressionPredictionFromJSON;
function AdSetImpressionPredictionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'estimatedImpressions': !(0, runtime_1.exists)(json, 'estimated_impressions') ? undefined : json['estimated_impressions'],
        'isBdlPassed': !(0, runtime_1.exists)(json, 'is_bdl_passed') ? undefined : json['is_bdl_passed'],
    };
}
exports.AdSetImpressionPredictionFromJSONTyped = AdSetImpressionPredictionFromJSONTyped;
function AdSetImpressionPredictionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'estimated_impressions': value.estimatedImpressions,
        'is_bdl_passed': value.isBdlPassed,
    };
}
exports.AdSetImpressionPredictionToJSON = AdSetImpressionPredictionToJSON;
